module.exports = __webpack_public_path__ + "img/toolbar-svg-orion.71f5a964.svg";